import * as API from "@/services/API";

export default {

    async insertBalance(payload) {
        return await API.apiClient.post('/api/transactions', payload);
    },
    async getTransactions(company_id, page_number, startDate, endDate) {
        return API.apiClient.get('/api/transaction/search/' + company_id + '?page=' + page_number, {
            headers: {
                'start-date': startDate,
                'end-date': endDate
            }
        });
    },

    async getTransactionsProduct(company_id, parent_inventory_id) {
        return API.apiClient.get('/api/transaction/products/' + company_id + '?parent_inventory_id=' + parent_inventory_id);
    },

    // ---- Claim / commission / salary (dedicated per-company panel) ----
    async addCategoryTransaction(payload) {
        return await API.apiClient.post('/api/company/category-transaction', payload);
    },
    async getCategoryTransactions(company_id, page_number, { category, startDate, endDate }: { category?: string; startDate?: string; endDate?: string } = {}) {
        const params: Record<string, string | number> = { page: page_number };
        if (category && category !== 'all') params['category'] = category;
        if (startDate) params['startDate'] = startDate;
        if (endDate) params['endDate'] = endDate;
        return API.apiClient.get('/api/company/category-transactions/' + company_id, { params });
    },
    async getCategoryTransactionsPdf(company_id, { category, startDate, endDate }: { category?: string; startDate?: string; endDate?: string } = {}) {
        const params: Record<string, string | number> = {};
        if (category && category !== 'all') params['category'] = category;
        if (startDate) params['startDate'] = startDate;
        if (endDate) params['endDate'] = endDate;
        return API.apiClient.get('/api/company/category-transactions/' + company_id + '/pdf', { params });
    },

    async getTransactionsPdf({ companyId, startDate, endDate }: { companyId?: number; startDate?: string; endDate?: string }) {
        const params: Record<string, string | number> = {};
        if (companyId && companyId > 0) {
            params['company_id'] = companyId;
        }
        if (startDate) {
            params['startDate'] = startDate;
        }
        if (endDate) {
            params['endDate'] = endDate;
        }

        return API.apiClient.get('/api/transaction/pdf', { params });
    }

}
